import {
  Badge,
  Divider,
  FormControl,
  FormLabel,
  Link,
  Stack,
  TextField,
  Typography,
  Box
} from '@mui/material'
import NextLink from 'next/link'
import { getPrivacyLink, getTermsLink } from 'utils'

import { LoadingButton } from '@mui/lab'
import { AuthButton } from 'ui-components/components/molecules/AuthButton'
import { AuthFormHeader } from '../FormHeader'
import { TurnstileWidget } from '../TurnstileWidget'

const defaultSlots = {
  Header: AuthFormHeader,
  UsernameForm: SignInUsernameForm,
  GoogleButton: AuthButton,
  FacebookButton: AuthButton,
  EmailButton: AuthButton
}

export function SignInForm(props) {
  const { dev, slots, slotProps } = props

  const Slots = {
    ...defaultSlots,
    ...slots
  }

  return (
    <>
      <Slots.Header
        {...slotProps?.Header}
        align='center'
        title='Sign in'
        subtitle={
          <Typography variant='next:subtitle1'>
            or{' '}
            <Link
              sx={{ cursor: 'pointer' }}
              underline='always'
              color='secondary'
              {...slotProps?.CreateAccountLink}
            >
              Create an account
            </Link>
          </Typography>
        }
      />

      <Slots.UsernameForm
        slots={slots?.UsernameForm}
        slotProps={slotProps?.UsernameForm}
      />

      <Divider textAlign='center'>
        <Typography variant='next:subtitle1'>or</Typography>
      </Divider>

      <Stack
        direction='column'
        gap={3}
      >
        <Slots.GoogleButton
          method='signInGoogle'
          {...slotProps?.GoogleButton}
        />
        <Slots.FacebookButton
          method='signInFacebook'
          {...slotProps?.FacebookButton}
        />
        {dev ? (
          <>
            <Badge
              badgeContent='Developer'
              color='primary'
            >
              <Slots.EmailButton
                fullWidth
                method='signInEmailPassword'
                {...slotProps?.EmailButton}
              />
            </Badge>
          </>
        ) : null}
      </Stack>

      <Typography variant='caption'>
        By continuing, you agree to Mapstack&apos;s&nbsp;
        <Link
          color='secondary'
          component={NextLink}
          href={getTermsLink()}
        >
          Terms of Use
        </Link>
        . Read our{' '}
        <Link
          color='secondary'
          component={NextLink}
          href={getPrivacyLink()}
        >
          Privacy Policy.
        </Link>
      </Typography>
    </>
  )
}

export function SignInUsernameForm(props) {
  const { slotProps } = props
  return (
    <Stack
      spacing={3}
      {...slotProps?.Form}
    >
      <FormControl>
        <FormLabel sx={{ typography: 'next:subtitle2' }}>Email</FormLabel>

        <TextField
          sx={{ mt: 1 }}
          variant='outlined'
          label={null}
          placeholder='name@company.com'
          {...slotProps?.EmailInput}
        />
        {slotProps?.TurnstileWidget?.showCaptcha && (
          <Box sx={{ mt: 1 }}>
            <TurnstileWidget {...slotProps?.TurnstileWidget} />
          </Box>
        )}
      </FormControl>

      <LoadingButton
        size='large'
        variant='contained'
        color='primary'
        {...slotProps?.Button}
      >
        Continue
      </LoadingButton>
    </Stack>
  )
}
